import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';
import { WEEKDAY_WEEK_HEATMAP_WEEKS } from '../../../utils/to-weekday-week-heatmap-series';

export const LENDING_RETURN_PACKAGE_VOLUME_WEEKDAY_HEATMAP_CHART_MOCK_DATA: Chart = createSingleSeriesTimeSeriesMockData({
    days: WEEKDAY_WEEK_HEATMAP_WEEKS * 7,
    scale: 0.45,
    seriesName: 'Incoming volume'
});
